module.exports = __webpack_public_path__ + "img/2_14.28e5d76d.png";